import styled from "styled-components";

export const TitleContainer = styled.div.attrs({})`
`;

export const VideoListContainer = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const VideoListTitle = styled.div.attrs({
})`
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: ${p => p.theme.palette.colors.black};
`;